import React, { ReactNode } from "react";
import RavenInputField from "./RavenInputField";
import { colors } from "./variable";

export interface ModalProps {
  visble?: true | false;
  btnColor?: colors["value"];
  onBtnClick: (e?: any | undefined) => void;
  children?: ReactNode;
  btnLabel?: string;
  className?: any;
  onClose?: () => void;
  outerClose?: boolean;
  loading?: true | false;
  disabled?: true | false;
  effect?: "fadeInUp" | "fadeInDown" | "fadeInLeft" | "fadeInRight";
  dontShowClose?: true | false;
  closeColor?: true | false;
}

const RavenModal: React.FC<ModalProps> = ({
  visble,
  btnColor,
  onBtnClick,
  btnLabel,
  children,
  className,
  onClose,
  loading,
  disabled,
  effect,
  dontShowClose,
  closeColor,
  outerClose,
}) => {
  return (
    <div
      style={{
        display: visble ? "unset" : "none",
      }}
      className={`modal-parent-wrap ${className}`}
    >
      <div
        onClick={
          !outerClose
            ? onClose
            : () => {
                ("");
              }
        }
        className="modal__close-div-wrap"
      ></div>
      <div
        className={`raven-modal-content-wrap raven-modal-content-wrap-${effect}`}
      >
        {/* close icon box start */}
        {!dontShowClose && (
          <div onClick={onClose} className="close-box">
            <figure className="img-box">
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                // fill=""
                xmlns="http://www.w3.org/2000/svg"
                className="img dull-bright-filter"
              >
                <path
                  d="M13 1L1 13M1 1L13 13"
                  stroke={closeColor ? "black" : undefined}
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </figure>
          </div>
        )}
        {/* close icon box end */}
        <div className="content">{children}</div>
        {/* button wrap start */}
        {btnLabel && (
          <div className="button-wrap">
            {/* <RavenButton
              label={btnLabel}
              loading={loading}
              color={btnColor}
              onClick={onBtnClick}
              size={"medium"}
              disabled={disabled}
            /> */}
            <form
              onSubmit={(e) => {
                // onBtnClick();
                e.preventDefault();
              }}
              action=""
              className="form"
            >
              <RavenInputField
                type={`submit`}
                value={btnLabel}
                onSubmit={onBtnClick}
                loading={loading}
                color={btnColor}
                disabled={disabled}
              />
            </form>
          </div>
        )}
        {/* button wrap end */}
      </div>
    </div>
  );
};

export default RavenModal;
